import axios from 'axios';
import _URL from '../../../Commons/URL/index'
export default {
    _API: _URL._API,
    _PUB_API: _URL._PUB,
    _IMAGE_URL: _URL._IMAGE_URL,
    axios: (token) => {
        return axios.create({
            baseURL: `${_URL._API}`,
            headers: { "Authorization": `${token}` }
        });
    },
}